import { render, staticRenderFns } from "./LayoutFormBasic.vue?vue&type=template&id=b74e1a3a&"
import script from "./LayoutFormBasic.vue?vue&type=script&lang=js&"
export * from "./LayoutFormBasic.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFormBasic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports